(function (ws, win) {
    'use strict';
    ws.views.productcard = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            // Refactor this and move to .tag file
            const readMore = this.$('.product-description').text();
            if (readMore.length > 105) {
                let finalDivText = readMore.substring(0, 105);
                finalDivText = finalDivText + '...';
                this.$('.product-description').text(finalDivText);
            }

            const $productTitle = this.$('.cpl-details h2');
            const readMoreTitle = $productTitle.text();
            if (readMoreTitle.length > 69) {
                let finalDivTextForTitle = readMoreTitle.substring(0, 69);
                finalDivTextForTitle = finalDivTextForTitle + '...';
                $productTitle.text(finalDivTextForTitle);
            }
        }
    });
})(westcon, window);
